// Runs before animations.js (product-list.js is loaded first in <head>) — blocks TextBlurIn auto-init
document.querySelectorAll('[data-hover-text], [data-mobile-blur]').forEach(function (el) {
  el.dataset.blurInit = '1';
});

class ProductList extends HTMLElement {
  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;
    this._initMobileBlur();
    this._initHover();
  }

  _splitBlurText(el) {
    if (el.dataset.blurSplit) return;
    el.dataset.blurSplit = '1';
    var words = el.textContent.split(' ');
    el.innerHTML = '';
    var charIndex = 0;
    words.forEach(function (word, i) {
      if (word === '') return;
      var wordSpan = document.createElement('span');
      wordSpan.style.display = 'inline-block';
      wordSpan.style.whiteSpace = 'nowrap';
      word.split('').forEach(function (char) {
        var span = document.createElement('span');
        span.textContent = char;
        span.style.transitionDelay = (charIndex * 22) + 'ms';
        wordSpan.appendChild(span);
        charIndex++;
      });
      el.appendChild(wordSpan);
      if (i < words.length - 1) el.appendChild(document.createTextNode(' '));
    });
  }

  _initMobileBlur() {
    var self = this;
    var els = this.querySelectorAll('[data-mobile-blur]');
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        io.unobserve(el);
        self._splitBlurText(el);
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            el.classList.add('focused');
          });
        });
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -20px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  _initHover() {
    var self = this;
    var MD = window.matchMedia('(min-width: 768px)');

    function reveal(card, show) {
      if (!MD.matches) return;
      card.querySelectorAll('[data-hover-reveal]').forEach(function (el) {
        clearTimeout(el._hideTimer);
        if (show) {
          el.style.visibility = 'visible';
          el.style.opacity = '1';
          el.querySelectorAll('[data-hover-text]').forEach(function (txt) {
            var isNew = !txt.dataset.blurSplit;
            self._splitBlurText(txt);
            txt.classList.remove('focused');
            var delay = parseInt(txt.dataset.hoverTextDelay, 10) || 0;
            if (isNew) {
              requestAnimationFrame(function () {
                requestAnimationFrame(function () {
                  setTimeout(function () { txt.classList.add('focused'); }, delay);
                });
              });
            } else {
              setTimeout(function () { txt.classList.add('focused'); }, delay);
            }
          });
        } else {
          el.style.opacity = '0';
          el.querySelectorAll('[data-hover-text]').forEach(function (txt) {
            txt.classList.remove('focused');
          });
          el._hideTimer = setTimeout(function () {
            el.style.visibility = 'hidden';
          }, 320);
        }
      });
    }

    this.querySelectorAll('a[href*="?variant="]').forEach(function (card) {
      card.addEventListener('mouseenter', function () { reveal(card, true); });
      card.addEventListener('mouseleave', function () { reveal(card, false); });
      card.addEventListener('focusin', function () { reveal(card, true); });
      card.addEventListener('focusout', function (e) {
        if (!card.contains(e.relatedTarget)) reveal(card, false);
      });
    });
  }
}

customElements.define('product-list', ProductList);
